/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_ListInputs */

const en_mk_shot_list = /** @type {(inputs: Mk_Shot_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng issue list with status, priority, labels and an assignee avatar on every row.`)
};

const id_mk_shot_list = /** @type {(inputs: Mk_Shot_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar issue KerjaBareng dengan status, prioritas, label, dan avatar penanggung jawab di setiap baris.`)
};

/**
* | output |
* | --- |
* | "KerjaBareng issue list with status, priority, labels and an assignee avatar on every row." |
*
* @param {Mk_Shot_ListInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_list = /** @type {((inputs?: Mk_Shot_ListInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ListInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_list(inputs)
	return en_mk_shot_list(inputs)
});